<template>
  <div class="vacancies-list-tab">
    <Alert v-if="!documents.length" text="Нет прикрепленных вакансий" />
    <SubpanelTable
      v-else
      module="HRPAC_VACANCY"
      :tableColumns="columns"
      :tableData="documents"
      :height="tableHeight.toString()"
    />
  </div>
</template>
<script>
import { store } from '@/store';
import Alert from 'Elements/Alert/Alert';
import SubpanelTable from 'Elements/Table/SubpanelTable.vue';

export default {
  components: { SubpanelTable, Alert },
  computed: {
    documents() {
      return (
        store.state.subpanels.activeSubpanelData['vacancies']?.data?.List || []
      );
    },
    columns() {
      return (
        store.state.subpanels.activeSubpanelData['vacancies']?.data?.title || {}
      );
    },
    tableHeight() {
      return (
        50 +
        store.state.subpanels.activeSubpanelData['vacancies']?.data?.List
          .length *
          48 +
        1.1 *
          store.state.subpanels.activeSubpanelData['vacancies']?.data?.List
            .length
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.vacancies-list-tab {
  margin: 24px;
}
</style>
